<template>
    <div class="h-full flex justify-center items-center" v-if="isLoading"><base-spinner></base-spinner></div>
    <div v-else class="w-full flex flex-col p-8 text-ternary text-left">
        <div class="flex justify-between items-center">
            <div @click.stop="$emit('edit')" class="flex justify-center items-center bg-white hover:bg-ternary border-ternary border px-4 py-2 rounded-lg cursor-pointer text-ternary hover:text-white mr-4">Edit</div>
            <div @click.stop="submitForm" class="flex justify-center items-center bg-ternary hover:bg-white border-ternary border px-4 py-2 rounded-lg cursor-pointer text-white hover:text-ternary">Confirm</div>
        </div>
        <h1 class="text-2xl font-bold underline mt-6">Training Group Details</h1>
        <div v-if="mode == 'edit'" class="flex flex-row flex-wrap mt-4">
            <div class="w-1/4 font-bold">Reference Number</div>
            <div class="w-3/4">{{ formData.ref_no }}</div>
        </div>
        <div class="flex flex-row flex-wrap" :class="mode == 'edit' ? 'mt-2' : 'mt-4'">
            <div class="w-1/4 font-bold">Name of Group</div>
            <div class="w-3/4">{{ formData.group_name }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Training Entity</div>
            <div class="w-3/4">{{ formData.partner_company_name }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Specialization</div>
            <div class="w-3/4">{{ formData.field_of_training }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Sector</div>
            <div class="w-3/4">{{ formData.sector }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Location</div>
            <div class="w-3/4">{{ formData.location }}</div>
        </div>
        <div class="flex flex-col" v-if="formData.sector == 'Private' || formData.sector == 'Semi-Government'">
            <div class="flex flex-row flex-wrap mt-2">
                <div class="w-1/4 font-bold">Trade License Authority</div>
                <div class="w-3/4">{{ formData.trade_license_authority }}</div>
            </div>
            <div class="flex flex-row flex-wrap mt-2">
                <div class="w-1/4 font-bold">Trade License Number</div>
                <div class="w-3/4">{{ formData.trade_license_number }}</div>
            </div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Supervisor</div>
            <div class="w-3/4">{{ formData.supervisor }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Start Date</div>
            <div class="w-3/4">{{ getInterviewDate(formData.start_date) }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">End Date</div>
            <div class="w-3/4">{{ getInterviewDate(formData.end_date) }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Entity</div>
            <div class="w-3/4">{{ formData.entity }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Campus</div>
            <div class="w-3/4">{{ formData.campus_code }}</div>
        </div>
        <div class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Program</div>
            <div class="w-3/4">{{ formData.program_name }}</div>
        </div>
        <div v-if="formData.trainingDocumentPreview" class="flex flex-row flex-wrap mt-2">
            <div class="w-1/4 font-bold">Training Document</div>
            <div class="w-3/4">
                <div @click.stop="showTrainingDocumentPreview = true" class="text-blue-600 hover:underline cursor-pointer">VIEW</div>
            </div>
        </div>
        <h1 class="text-2xl font-bold mt-6"><span class="underline">Selected Students</span> ({{ selectedStudentsCount }})</h1>
        <div class="flex flex-col mt-2">
            <div class="flex flex-col overflow-x-auto">
                <div class="inline-block min-w-full py-2">
                    <div class="overflow-x-auto">
                        <table class="min-w-full text-left text-sm font-light">
                            <thead class="border-b font-medium dark:border-neutral-500">
                                <tr>
                                    <th scope="col" class="px-6 py-2 text-gray-400 w-8">#</th>
                                    <th scope="col" class="px-6 py-2 text-gray-400">Fullname</th>
                                    <th scope="col" class="px-6 py-2 text-gray-400">Student ID</th>
                                    <th scope="col" class="px-6 py-2 text-gray-400">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in items" :key="index" class="border-b border-dashed dark:border-neutral-500">
                                    <td class="whitespace-nowrap px-6 py-2 font-medium">{{ index + 1 }}</td>
                                    <td class="whitespace-nowrap px-6 py-2 capitalize hover:text-blue-600 hover:underline cursor-pointer" @click.stop="$emit('view-student-profile', item.student_id)">{{ item.fullname }}</td>
                                    <td class="whitespace-nowrap px-6 py-2">{{ item.student_id }}</td>
                                    <td class="whitespace-nowrap px-6 py-2">
                                        <div @click.stop="$emit('view-student-profile', item.student_id)" class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                            <icon-eye class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-eye>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex justify-start items-center mt-6">
            <div @click.stop="$emit('edit')" class="flex justify-center items-center bg-white hover:bg-ternary border-ternary border px-4 py-2 rounded-lg cursor-pointer text-ternary hover:text-white mr-4">Edit</div>
            <div @click.stop="submitForm" class="flex justify-center items-center bg-ternary hover:bg-white border-ternary border px-4 py-2 rounded-lg cursor-pointer text-white hover:text-ternary">Confirm</div>
        </div>

        <transition name="fade" mode="out-in">
            <base-full-modal v-if="showTrainingDocumentPreview" :title="`View Training Document - ${formData.training_document.name}`" @close="showTrainingDocumentPreview = false">
                <iframe v-if="formData.trainingDocumentPreview" :src="formData.trainingDocumentPreview" width="100%" :height="getIframeHeight" frameborder="0"></iframe>
            </base-full-modal>
        </transition>
    </div>
</template>

<script>
import gql from 'graphql-tag';
import { formattedDate } from "../../helpers/utils";
import IconEye from "../../components/icons/IconEye.vue";
export default {
    name: "internship-review",
    components: { IconEye, },
    emits: ["view-student-profile", "edit", "created", "updated", "close"],
    props: ["item", "formData", "internshipId", "mode"],
    data() {
        return {
            isLoading: false,
            showTrainingDocumentPreview: false,
        };
    },
    computed: {
        selectedStudentsCount() {
            return this.formData.selected_candidates.length;
        },
        items() {
            return this.formData.selected_candidates;
        },
        getIframeHeight() {
            return `${window.innerHeight} px`;
        },
    },
    methods: {
        getInterviewDate(date) {
            return formattedDate(date);
        },

        async submitForm() {
            delete this.formData.partner_company_name;
            delete this.formData.ref_no;
            delete this.formData.trade_license_authority;
            delete this.formData.trade_license_number;
            delete this.formData.program_name;
            delete this.formData.un_selected_candidates;
            delete this.formData.trainingDocumentPreview;
            
            const CREATE_MUTATION = gql`
                mutation CreateInternship($input: CreateInternshipInput!) {
                    createInternship(input: $input) {
                        error
                        message
                    }
                }
            `;

            const UPDATE_MUTATION = gql`
                mutation UpdateInternship($id: ID!, $input: CreateInternshipInput!) {
                    updateInternship(id: $id, input: $input) {
                        error
                        message
                    }
                }
            `;

            this.isLoading = true;
            let error = null;
            let success = null;

            try {
                await this.$apollo.mutate({
                    mutation: this.mode == 'create' ? CREATE_MUTATION : UPDATE_MUTATION,
                    variables: {
                        id: this.mode == 'edit' ? this.internshipId : null,
                        input: this.formData
                    },
                    context: {
                        headers: {
                            'content-type': 'multipart/form-data',
                        },
                    },
                }).then((data) => {
                    if (this.mode == 'create') {
                        if (data.data.createInternship.error) {
                            error = data.data.createInternship.message;
                        } else {
                            success = data.data.createInternship.message;
                        }
                    } else {
                        if (data.data.updateInternship.error) {
                            error = data.data.updateInternship.message;
                        } else {
                            success = data.data.updateInternship.message;
                        }
                    }
                }).catch((err) => {
                    error = err;
                })

            } catch (err) {
                error = err.message || "Failed to authenticate, try later.";
            }

            if (error === null) {
                if (this.mode == 'create') {
                    this.$emit('created', success);
                } else {
                    this.$emit('updated', success);
                }
            } else {
                this.$swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: error,
                }).then((result) => {
                    if (result.value || result.dismiss) {
                        this.$emit('close');
                    }
                })
            }

            this.isLoading = false;

        },
    },
}
</script>